import { SelectChangeEvent } from "@mui/material";
import BriaDropDown from "../../../../../components/common/BriaDropDown/BriaDropDown";
import useStaticDropdown from "../../../../../components/common/DropDowns/useStaticDropdown";
import { AvailableTrainingModels } from "../../../../../models/new-iframe";
import iframeStore from "../../../iframe-store";

type IframeTgTrainingOptions = "both_types" | "only_fully_automated";

const IframeTgTrainingConfig = () => {
	const { items } = useStaticDropdown<IframeTgTrainingOptions>({
		tKeyPrefix: "newIframes.editor.form.tgTrainingConfig.availableTrainingModels.options",
	});
	const { iframeForm, handleFormChange } = iframeStore;

	const getCurrentDropdownValue = (): IframeTgTrainingOptions => {
		const enabledModels = iframeForm.config.tg_training_config?.enabled_training_models;
		return enabledModels?.expert ? "both_types" : "only_fully_automated";
	};

	const getBooleanObjectFromDropdown = (
		dropdownValue: IframeTgTrainingOptions,
	): { [key in AvailableTrainingModels]: boolean } => {
		return {
			expert: dropdownValue === "both_types",
			fully_automated: true,
		};
	};

	const handleChangeAvailableTrainingModels = (e: SelectChangeEvent<IframeTgTrainingOptions>) => {
		handleFormChange("config", {
			...iframeForm.config,
			tg_training_config: {
				...iframeForm.config.tg_training_config,
				enabled_training_models: getBooleanObjectFromDropdown(e.target.value as IframeTgTrainingOptions),
			},
		});
	};

	return (
		<BriaDropDown<IframeTgTrainingOptions>
			items={items}
			value={getCurrentDropdownValue()}
			onChange={handleChangeAvailableTrainingModels}
		/>
	);
};

export default IframeTgTrainingConfig;
